import {Flex, Image, Stack, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import React from 'react'
import PropTypes from 'prop-types'

const DeliveryItem = ({method, styles}) => {
    const {formatMessage} = useIntl()
    return (
        <Stack {...styles.itemContainer}>
            {method.c_image ? (
                <Image
                    layerStyle="checkoutLogo"
                    alt={formatMessage(
                        {
                            id: 'global.shipping_company_logo',
                            defaultMessage: 'Shipping company logo - {name}'
                        },
                        {
                            name: method.name
                        }
                    )}
                    src={method.c_image}
                />
            ) : null}
            <Text {...styles.itemLabel}>{method?.c_estimatedArrivalTime}</Text>
        </Stack>
    )
}

DeliveryItem.propTypes = {
    method: PropTypes.shape({
        c_image: PropTypes.string,
        c_estimatedArrivalTime: PropTypes.string,
        name: PropTypes.string
    }),
    styles: PropTypes.object
}

const CartDelivery = ({shippingMethods, variant}) => {
    const styles = useMultiStyleConfig('CartDelivery', {variant})

    if (!shippingMethods) return null
    return (
        <Flex {...styles.container}>
            <Text {...styles.label} as="h2">
                <FormattedMessage
                    defaultMessage="Order now and have it delivered on:"
                    id="cart_delivery.heading.cart_delivery"
                />
            </Text>
            {shippingMethods?.applicableShippingMethods?.map((method) => (
                <DeliveryItem key={method.id} method={method} styles={styles} variant={variant} />
            ))}
        </Flex>
    )
}

CartDelivery.propTypes = {
    shippingMethods: PropTypes.object,
    variant: PropTypes.string
}

export default CartDelivery
